import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import {
	LightsImage,
	LightsImageProvider
} from '@shure/shared/angular/features/device-lights-settings/feature-device-image-next';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Mxa320CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin implements LightsImageProvider {
	public override readonly models: DeviceModel[] = [DeviceModel.MXA320];

	public getLightsImage(): LightsImage {
		return {
			imageUrl: 'device-mxa3xx.svg'
		};
	}
}
